'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require('redux');

/**
 * Helper method to configure store for redux
 */
function configureStore(rootReducer) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var _len = arguments.length, middlewares = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    middlewares[_key - 2] = arguments[_key];
  }

  var mids = [_redux.applyMiddleware.apply(undefined, middlewares)];

  return (0, _redux.createStore)(rootReducer, initialState, _redux.compose.apply(undefined, mids));
}